export const bannerInfosData = [
  {
    BannerTitle: "Product selected FOR YOU ",
    BannerSubTitle: "YOUR UNIQUE EXPERIENCE BEGINS WITH YOUR INSPIRATIONS",
   // BannerSubTitleFollow: "WITH YOUR INSPIRATIONS",
    BannerDiscription:
      "Step into a world of personalized experiences with our FOR YOU section. Share your mood boards, and our dedicated team will handpick products from our diverse selection that perfectly match your interests. Embrace the extra attention and time-saving for your one-of-a-kind experience!",
    /*     BannerButtonText: "Go to for you",
     */ shadowBlock: false,
    buttonDistance: "80px",
  },
  {
    BannerTitle: "Direct Order",
    BannerSubTitle: "YOUR VISION, OUR CRAFTMANSHIP PLACE YOUR ODER IN ONE CLICK ",
/*
    BannerSubTitleFollow: "PLACE YOUR ODER IN ONE CLICK",
*/
    BannerDiscription:
      "In our Direct Order Section, your vision takes center stage! Forget product limitations and embrace the freedom to upload orders based on your unique ideas. Complete customization awaits, allowing you to submit designs, specifications, and requirements for bespoke products tailored precisely to your vision. Our skilled team is committed to bringing your distinct ideas to life with precision and attention to detail. You can even opt for a 3D sample preview before finalizing your product, ensuring utmost satisfaction while minimizing waste. ",
    /*     BannerButtonText: "Send your order",
     */ shadowBlock: false,
    buttonDistance: "80px",
  },
  {
    BannerTitle: "Our Philosophy",
    BannerSubTitle: "We stand for",
    BannerSubTitleFollow: "innovative thinking !",
    BannerDiscription: `High expectations on design, quality and material as well as the latest processing technologies. Our goal is to continually find sustainable ways to improve our performance to assure an outstanding service in order to continuously exceed our customers’ expectations.`,
    BannerButtonText: "Go to creative station",
    shadowBlock: false,
    buttonDistance: "80px",
  },

  {
    BannerTitle: "Product Customization",
    BannerSubTitle: "ENDLESS CUSTOMIZATION PERSONALIZED TO YOUR VISION",
/*
    BannerSubTitleFollow: "PERSONALIZED TO YOUR VISION",
*/
    BannerDiscription: `Personalize any product to your precise specifications, from fit to fabric and more. You even have the option to request a 3D sample for approval before proceeding with the prototype, minimizing unnecessary waste. Our skilled team is dedicated to bringing your distinct vision to life, harnessing your creativity to design one-of-a-kind products. The possibilities are limitless! Your personalized masterpiece is just a step away.`,
    /*   BannerButtonText: "Go to  products",
     */ shadowBlock: false,
    buttonDistance: "80px",
  },
];

export const bannerInfosCustomization = {
  BannerTitle: "Product Customization",
  BannerSubTitle: "ENDLESS CUSTOMIZATION PERSONALIZED TO YOUR VISION ",
/*
  BannerSubTitleFollow: "PERSONALIZED TO YOUR VISION",
*/
  BannerDiscription: `Personalize any product to your precise specifications, from fit to fabric and more. You even have the option to request a 3D sample for approval before proceeding with the prototype, minimizing unnecessary waste. Our skilled team is dedicated to bringing your distinct vision to life, harnessing your creativity to design one-of-a-kind products. The possibilities are limitless! Your personalized masterpiece is just a step away.`,
  /*   BannerButtonText: "Go to  products",
   */ shadowBlock: true,
  buttonDistance: "80px",
};

export const bannerInfosDifference = {
  BannerTitle: "The Creative Team ",
  BannerSubTitle: "CRAFTING INNOVATION AND STYLE TO MEET AMBITIOUS EXPECTIONS",
/*
  BannerSubTitleFollow: "TO MEET AMBITIOUS EXPECTIONS",
*/
  BannerDiscription: `Discover our exceptional Creative Team, comprising of over 40 dedicated individuals who excel in sales, research, and development. Specializing in creating impeccable fits with pattern designs, we utilize cutting-edge Gerber and Lectra software for precise craftsmanship. Our forward-thinking R&D team leverages 3D design with CLO3D to stay at the forefront of innovation, while our fully equipped smart wash lab ensures top-notch product quality. Managed by skilled photographers, our advanced studios bring you 360-degree product visuals and a constantly growing digital library. With creativity as our core, we aim to exceed expectations and set new industry standards with captivating visuals that resonate with our valued customers. `,
  shadowBlock: true,
  buttonDistance: "80px",
};
